import Gauge from './Gauge/Gauge';

const templates = {
    Gauge
};

export default templates;
